import { type FC, type ReactNode, useCallback } from "react";

import { TriangleDownIcon, TriangleUpIcon } from "@snapchat/snap-design-system-icons";

import { usePagination } from "../../../../core/pagination/hooks";
import { MyLensesSortDirection, type SortBy } from "../../../../gql-generated/types";

import { ClickableHeaderItem, sortIcon } from "./LensesListHeader.styles";

interface SortableHeaderItemProps {
    className?: string;
    type: SortBy;
    children?: ReactNode;
}

export const SortableHeaderItem: FC<SortableHeaderItemProps> = ({ className, type, children }) => {
    const {
        pagination: { sortBy, sortDirection },
        onSortChange,
    } = usePagination();

    const handleSortChange = useCallback(() => {
        onSortChange(type);
    }, [type, onSortChange]);

    if (type === sortBy) {
        let SortIcon = null;

        switch (sortDirection) {
            case MyLensesSortDirection.SortDirectionAsc:
                SortIcon = <TriangleUpIcon size={12} className={sortIcon} />;
                break;
            case MyLensesSortDirection.SortDirectionDesc:
                SortIcon = <TriangleDownIcon size={12} className={sortIcon} />;
                break;
        }

        return (
            <ClickableHeaderItem className={className} onClick={handleSortChange}>
                {children}
                {SortIcon}
            </ClickableHeaderItem>
        );
    }

    return (
        <ClickableHeaderItem className={className} onClick={handleSortChange}>
            {children}
        </ClickableHeaderItem>
    );
};
